import eventListener from '@synergycms_core/middlewares/eventListener';

import actions from './store/actions';
import { refreshLoyaltyReservation } from './store/customer/loyaltyActions';
import { refreshCorporateReservation } from './store/customer/corporateActions';


const {
  loyalty: loyaltyActions,
  corporate: corporateActions,
} = actions.customer;

export default eventListener("loyalty", [{
  name : "setSessionLoyalty",
  effect : (data, { dispatch, getState }) => {
    dispatch(loyaltyActions.update(data));
    dispatch(loyaltyActions.setLoyaltyTier(data));
    dispatch(actions.customer.loyalty.saveSearch())

    refreshLoyaltyReservation({ dispatch, getState });
  }
},
{
  name : "setSessionCompany",
  effect : (data, { dispatch, getState }) => {
    dispatch(corporateActions.update(data));
    refreshCorporateReservation({ dispatch, getState });
  }
},{
  name : "destroySession",
  effect : (data, { dispatch, getState }) => {
    const store = getState();
    if(store.getIn(['customer', 'loyalty','user','user_id'])){
      dispatch(actions.customer.loyalty.logout());
    }

    if(store.getIn(['customer', 'corporate']) || false){
      dispatch(actions.customer.corporate.logout());
    }
  }
}]);
